import React from 'react';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import { ColorModePropKeys } from 'styles/colors';
import { SpacingPropKeys } from 'styles/spacing';

export interface FeaturedIconProps {
  icon?: React.ReactNode;
  padding?: SpacingPropKeys;
  background?: ColorModePropKeys;
}

const FeaturedIcon = ({
  icon,
  padding = 'spacing-lg',
  background = 'base-transparent',
}: FeaturedIconProps): JSX.Element => {
  return (
    <Stack
      padding={padding}
      background={background}
      borderRadius='radius-lg'
      border='1px solid var(--border-primary)'
      justify='center'
    >
      {icon}
    </Stack>
  );
};

export default FeaturedIcon;
